export const PlayerNumberToColor = (playerNumber: number): string => {
    switch (playerNumber) {
        case 1:
            return 'blue'
        case 2:
            return 'red'
        case 3:
            return 'yellow';
        case 4:
            return 'green';
        default:
            console.error(`Can't find color for number: ${playerNumber}`);
            return '';
    }
}